import React from 'react';

class SignageLayoutSlot extends React.Component{
    render(){
        const {slotdata, scaleX=1, scaleY=1} = this.props;
        const x = slotdata.x;
        const y = slotdata.y;
        const width = slotdata.width;
        const height = slotdata.height;
        const zIndex = slotdata["z-index"];

        const newX = parseFloat(x)* parseFloat(scaleX);
        const newY =  parseFloat(y)* parseFloat(scaleY);
        const newWidth =  parseFloat(width)* parseFloat(scaleX);
        const newHeight =  parseFloat(height)* parseFloat(scaleY);

        
        // console.log("newX : " + newX);
        // console.log("newY : " + newY);
        // console.log("newWidth : " + newWidth);
        // console.log("newHeight : " + newHeight);
        return(
            <div key={slotdata.slot_id} style={{overFlow:'hidden', position:'absolute', top:newY, left:newX, width:newWidth, height:newHeight, zIndex:zIndex}}>
                {this.props.children}
            </div>
        );
    }

    // getRandomColor = () => {
    //     return '#'+(0x1000000+(Math.random())*0xffffff).toString(16).substr(1,6);
    // }
}

export default SignageLayoutSlot